import React from 'react';
import Dialog from 'material-ui/Dialog';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import FlatButton from 'material-ui/FlatButton';
import TimePicker from 'material-ui/TimePicker';
import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';

const UpdateAppointmentDialog = ({disableSubmit, selectedAppointment, open, updated_start_time, onChange, submitReschedule, onSelectDoctor, toggleUpdateAppointment, onDateChange, dateToReschedule, doctors, assignedDoc}) => {
  const styles = {
    select: {
      width: '30%'
    },
    timePicker: {
      marginLeft: '50px'
    },
    label: {
      marginTop: '25px',
    },
    labelTime: {
      marginTop: '25px',
      marginLeft: '55px'
    }
  }
  const actions = [
    <FlatButton
      label="Cancel"
      secondary={true}
      onTouchTap={toggleUpdateAppointment} />,
    <FlatButton
      label="Submit"
      primary={true}
      disabled={disableSubmit}
      onTouchTap={submitReschedule.bind(null)} />
  ];

  return (
    <div>
      <Dialog
        title='Reschedule Appointment'
        actions={actions}
        modal={false}
        open={open}
        autoScrollBodyContent={true}
        onRequestClose={toggleUpdateAppointment.bind(null, false, {})} >
        <div className="row" style={styles.label}>
        <label>Current Doctor: {selectedAppointment && selectedAppointment.doctor.user.name}</label>
        </div>
        <div className="row">
        <SelectField
          floatingLabelText="Change Doctor"
          value={assignedDoc}
          onChange={onSelectDoctor}
          style={styles.select}
        >
        {
          doctors
          .sort((doctorA, doctorB) => {
            if (doctorA.user.name < doctorB.user.name) {
              return -1;
            }
            else if (doctorA.user.name > doctorB.user.name) {
              return 1;
            }
            else
               return 0;
          })
          .map(d => 
            <MenuItem 
            primaryText={d.user.name}
            key={d.id}
            value={d}/>
          )
        }
        </SelectField>
        </div>
        <div className="row" >
        <label className="column" style={styles.label}>Current Start Date: {selectedAppointment && moment(selectedAppointment.start_time).format('YYYY/MM/DD')}</label>
        <label className="column" style={styles.labelTime}>Current Start Time: {selectedAppointment && moment(selectedAppointment.start_time).format('hh:mm A')}</label>
        </div>
        <div className="row">
          <div className="column">
            <DatePicker
              value={dateToReschedule}
              floatingLabelText="Select Date to Change"
              firstDayOfWeek={0}
              onChange={onDateChange.bind(this, 'dateToReschedule')} 
            />
          </div>
          <div className="column" style={styles.timePicker}>
            <TimePicker
              format='ampm'
              floatingLabelText="Pick to change start time"
              value={updated_start_time}
              onChange={onChange.bind(null, 'updated_start_time')} 
            />
          </div>
        </div>

      </Dialog>
    </div>
  )
};

export default UpdateAppointmentDialog;


// WEBPACK FOOTER //
// ./src/screens/appointments/update-appointment.js